import { getDateFormatYMD2 } from "@/utils/date-formatter/getDateFormatYMD2";
import {
  getStartDate,
  getEndDate,
  // ONE_SECOND_SHORT,
} from "@/utils/date-formatter/getToday";

export function enhanceEndNoDayTime(value: [string, string]) {
  return {
    startTime: value?.[0]
      ? new Date(getStartDate(value[0])).getTime()
      : undefined,
    endTime: value?.[1] ? new Date(getEndDate(value[1])).getTime() : undefined,
  };
}

export function enhanceEndTime(value: [string, string]) {
  return {
    startTime: value?.[0]
      ? new Date(getStartDate(value[0])).getTime()
      : undefined,
    endTime: value?.[1]
      ? new Date(getStartDate(value[1])).getTime() + 24 * 60 * 60 * 1000 - 1
      : undefined,
  };
}

export function enhanceEndDate(value: [Date, string]) {
  return {
    startDate: value?.[0]
      ? getDateFormatYMD2(new Date(value[0])) + " 00:00:00"
      : undefined,
    endDate: value?.[1]
      ? getDateFormatYMD2(new Date(value[1])) + " 23:59:59"
      : undefined,
  };
}

export function formatTime(value: [Date, Date]) {
  return {
    submitDate: value?.[0]
      ? new Date(getStartDate(value[0])).getTime()
      : undefined,
    completedDate: value?.[1]
      ? new Date(getStartDate(value[1])).getTime() + 24 * 60 * 60 * 1000 - 1
      : undefined,
  };
}
